/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiNoteFromJSON, StreemApiNoteToJSON, StreemApiRoomFromJSON, StreemApiRoomToJSON, } from './';
export function StreemApiEventsRoomNoteFinalizedFromJSON(json) {
    return StreemApiEventsRoomNoteFinalizedFromJSONTyped(json, false);
}
export function StreemApiEventsRoomNoteFinalizedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'room': !exists(json, 'room') ? undefined : StreemApiRoomFromJSON(json['room']),
        'roomNote': !exists(json, 'room_note') ? undefined : StreemApiNoteFromJSON(json['room_note']),
    };
}
export function StreemApiEventsRoomNoteFinalizedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room': StreemApiRoomToJSON(value.room),
        'room_note': StreemApiNoteToJSON(value.roomNote),
    };
}
//# sourceMappingURL=StreemApiEventsRoomNoteFinalized.js.map